// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Resume_bloc__OwhPU {
  background-color: #FFFFFF;
  border: 1px solid #d8d8ff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
  color: #00007a;
  font-weight: 300;
  line-height: 28px;
}
.Resume_bloc__OwhPU h2 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
}
.Resume_bloc__OwhPU > svg {
  float: right;
  cursor: pointer;
}

.Resume_documents__QDc7Q {
  margin: 0;
}
.Resume_documents__QDc7Q * {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.Resume_documents__QDc7Q svg {
  margin-right: 4px;
}

.Resume_checkbox__FLlop {
  border: 1px solid #d8d8ff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
}
.Resume_checkbox__FLlop a {
  text-decoration: underline;
}
.Resume_checkbox__FLlop label {
  font-weight: 300;
  width: 100%;
}
.Resume_checkbox__FLlop span {
  display: inline;
}

.Resume_restrictions__v-g6\\+ {
  width: 100%;
  margin: 0;
  display: inline-block;
}
.Resume_restrictions__v-g6\\+ li {
  list-style-type: none;
}
.Resume_restrictions__v-g6\\+ li > div {
  max-width: calc(100% - 30px);
  display: inline-block;
}
.Resume_restrictions__v-g6\\+ li > svg {
  margin-left: 10px;
  margin-right: 10px;
}
.Resume_restrictions__v-g6\\+ li li > div {
  max-width: calc(100% - 20px);
  display: inline-block;
}
.Resume_restrictions__v-g6\\+ li li svg {
  margin-left: 5px;
  margin-right: 2px;
}
.Resume_restrictions__v-g6\\+ svg {
  width: 6px;
  height: auto;
  margin-top: 12px;
  vertical-align: top;
  display: inline-block;
}`, "",{"version":3,"sources":["webpack://./src/components/RCPro/pages/Resume/Resume.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAEA;EACI,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,cCDO;EDEP,gBAAA;EACA,iBAAA;AAKJ;AAHI;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;AAKR;AAFI;EACI,YAAA;EACA,eAAA;AAIR;;AAAA;EACI,SAAA;AAGJ;AADI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AAGR;AAAI;EACI,iBAAA;AAER;;AAEA;EACI,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AACJ;AACI;EAAG,0BAAA;AAEP;AADI;EAAO,gBAAA;EAAkB,WAAA;AAK7B;AAJI;EAAO,eAAA;AAOX;;AAJA;EACI,WAAA;EACA,SAAA;EACA,qBAAA;AAOJ;AALI;EACI,qBAAA;AAOR;AALQ;EACI,4BAAA;EACA,qBAAA;AAOZ;AAJQ;EACI,iBAAA;EACA,kBAAA;AAMZ;AAFY;EACI,4BAAA;EACA,qBAAA;AAIhB;AADY;EACI,gBAAA;EACA,iBAAA;AAGhB;AAEI;EACI,UAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AAAR","sourcesContent":["@use 'styles/colors.scss';\n\n.bloc{\n    background-color: #FFFFFF;\n    border: 1px solid colors.$primary2;\n    border-radius: 12px;\n    padding: 16px;\n    margin-bottom: 12px;\n    color: colors.$primary8;\n    font-weight: 300;\n    line-height: 28px;\n\n    h2{\n        font-size: 16px;\n        font-weight: 600;\n        margin-bottom: 8px;\n    }\n\n    >svg{\n        float: right;\n        cursor: pointer;\n    }\n}\n\n.documents{\n    margin: 0;\n\n    *{\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n\n    svg{\n        margin-right: 4px;\n    }\n}\n\n.checkbox{\n    border: 1px solid colors.$primary2;\n    border-radius: 12px;\n    padding: 16px;\n    margin-bottom: 12px;\n\n    a{ text-decoration: underline; }\n    label{ font-weight: 300; width: 100%; }\n    span { display: inline; }\n}\n\n.restrictions{\n    width: 100%;\n    margin: 0;\n    display: inline-block;\n\n    li{\n        list-style-type: none;\n\n        > div {\n            max-width: calc(100% - 30px);\n            display: inline-block;\n        }\n\n        > svg{\n            margin-left: 10px;\n            margin-right: 10px;\n        }\n\n        li{\n            > div {\n                max-width: calc(100% - 20px);\n                display: inline-block;\n            }\n\n            svg{\n                margin-left: 5px;\n                margin-right: 2px;\n            }\n        }\n    }\n\n    svg{\n        width: 6px;\n        height: auto;\n        margin-top: 12px;\n        vertical-align: top;\n        display: inline-block;\n    }\n\n    // > li{\n    //     padding-left: 10px;\n    // }\n\n    // > li:has(ul){\n    //     padding-left: 25px;\n    // }\n}","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"bloc": `Resume_bloc__OwhPU`,
	"documents": `Resume_documents__QDc7Q`,
	"checkbox": `Resume_checkbox__FLlop`,
	"restrictions": `Resume_restrictions__v-g6+`
};
export default ___CSS_LOADER_EXPORT___;
